"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_env_scopes_1 = __importDefault(require("../enums/model-env-scopes"));
const model_scopes_1 = __importDefault(require("../enums/model-scopes"));
const GraphandFieldRelation_1 = __importDefault(require("../lib/fields/GraphandFieldRelation"));
const GraphandFieldText_1 = __importDefault(require("../lib/fields/GraphandFieldText"));
const GraphandModel_1 = __importDefault(require("../lib/GraphandModel"));
/**
 * @class OrgInvitation
 * @augments GraphandModel
 */
class OrgInvitation extends GraphandModel_1.default {
    async accept() {
        const { constructor } = Object.getPrototypeOf(this);
        await constructor._client._axios.post(`/organizations/invitations/${this._id}/accept`);
    }
}
OrgInvitation._customFields = {};
OrgInvitation.apiIdentifier = "orginvitations";
OrgInvitation.baseUrl = "/organizations/invitations";
OrgInvitation.isGlobal = true;
OrgInvitation.scope = model_scopes_1.default.OrgInvitation;
OrgInvitation.envScope = model_env_scopes_1.default.GLOBAL;
OrgInvitation.schema = {
    email: new GraphandFieldText_1.default(),
    organization: new GraphandFieldRelation_1.default({ ref: "Organization", multiple: false }),
};
exports.default = OrgInvitation;
